/**
 * The one-screen "create your first page" (`111-frontend-architecture.md` §7 —
 * `/welcome`, where `RootRedirect` lands when there is no page to open).
 *
 * 110 §1.1: no hero areas. One line of text and one action.
 */
import { useTranslation } from '@/lib/i18n';

export function Welcome() {
  const { t } = useTranslation();

  return (
    <div className="max-w-[78ch] p-6">
      <h1 className="mb-1 text-2xl font-semibold">{t('notebook.welcome.empty')}</h1>
      <p className="text-[var(--muted-foreground)]">{t('notebook.welcome.body')}</p>
    </div>
  );
}
